<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.services'), $t('text.list')]">
        <span v-if="Permit.canActions('serviceManage')">
          <el-button
            type="success"
            size="mini"
            @click="$router.push('/normal/pdm/services/new')"
            >+ {{ $t("text.create") }}</el-button
          >
        </span>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-checkbox
              v-model="checkAllDF"
              value="1"
              style="margin-right: 10px"
              @change="checkAll"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-popconfirm
              v-if="Permit.canActions('serviceDelete')"
              :title="$t('prompt.confirmDelete')"
              @confirm="batchDelete"
              class="mgl10"
            >
              <el-button slot="reference" type="danger" size="mini">
                {{ $t("text.delete") }}
              </el-button>
            </el-popconfirm>

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
                <el-dropdown-item command="checkedWithImg">{{
                  $t("action.downLoadCheckedWithImg")
                }}</el-dropdown-item>
                <el-dropdown-item command="searchWithImg">{{
                  $t("action.downLoadSearchWithImg")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </vxe-toolbar>
      </sticky>
      <div :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <div class="product-checkbox-div" style="z-index: 2">
                      <input
                        v-model="checkedProducts"
                        type="checkbox"
                        :value="row"
                        class="float-right"
                        @change="checkedProduct"
                      />
                    </div>
                    <thumbnail
                      :images="row.images"
                      width="auto"
                      height="100%"
                    />
                  </div>
                  <div class="pd5">
                    <el-row class="mgb5">
                      <el-col :span="20" class="overflow">
                        <span class="a" @click="showRow(row, rowIndex)">
                          {{ row.productNo }}
                        </span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 21px">
                          {{ row.categoryName }}
                        </div>
                      </el-col>
                      <el-col
                        v-if="Permit.canActions('globalRentPrice')"
                        :span="12"
                        class="overflow right red"
                      >
                        {{ row.rentPrice | currency }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="14">
                        <span style="height: 28px; line-height: 28px">
                          <span
                            v-if="Permit.canActions('serviceManage')"
                            class="a font10 mgr8"
                            @click="editRow(row, rowIndex)"
                            >{{ $t("text.edit") }}</span
                          >
                          <el-popconfirm
                            v-if="Permit.canActions('serviceDelete')"
                            :title="$t('prompt.confirmDelete')"
                            @confirm="deleteRow(row)"
                          >
                            <span
                              slot="reference"
                              type="text"
                              class="a font10 mgr8"
                            >
                              {{ $t("text.delete") }}
                            </span>
                          </el-popconfirm>
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
      </div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" @updateInfo="showRowClose" />
    </drawer>

    <drawer
      :title="$t('text.edit')"
      :visible.sync="showEditDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit :id="currentRowId" @updateInfo="editRowClose" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import QRCode from "qrcode";
import PagerConfig from "@/config/pager.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
// import PrintTemplate from "@/api/printTemplate.js";
import Show from "./show.vue";
import Edit from "./edit.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Qrcode,
    QRCode,
    Show,
    Edit,
    RawHtmlLimitNumber,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      // 设置只能选择今天以后
      pickerTodayAfterTime: {
        pickerTodayAfterTime(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      narrows: [
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("service.productNoRepeat"),
                key: "productNoRepeat",
                condition: { special: "productNoRepeat" },
                numberFun: Product.repeatCount,
                emitNames: ["productUpdate", "productDelete"],
              },
            ],
          },
        ],
      ],

      searchForm: {
        productNo: null,
      },
      materials: [],
      serialNosLoading: false,
      sorter: {
        sortBy: "product_id",
        sortIndicator: "desc",
      },
      Util: Util,
      checkedProducts: [],
      checkAllDF: false,

      // 颜色
      isIndeterminateColors: false,
      checkedColors: [],
      checkAllColors: false,
      searchColorsJiaojiName: null,
      colorsJiaojiFilter: [],
      // 尺码
      isIndeterminateSizes: false,
      checkedSizes: [],
      checkAllSizes: false,
      searchSizesJiaojiName: null,
      sizesJiaojiFilter: [],

      //
      currentRowId: null,
      currentRowIdx: null,
      showDF: false,
      showEditDF: false,
    };
  },
  computed: {
    implicit() {
      return {
        type: "service",
      };
    },
  },
  created() {
    const self = this;
    axios.all([Category.serviceCategory()]).then(
      axios.spread(function (categories) {
        if (categories.status === 200) {
          if (categories.data.length !== 0) {
            self.narrows.push([
              {
                label: self.$t("menu.categories"),
                items: categories.data.map((category) => {
                  return {
                    label: category.name,
                    key: category.id,
                    condition: { categoryId: category.id },
                  };
                }),
              },
            ]);
          }
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    //
    editRow(row, rowIndex) {
      this.currentRowId = row.id;
      this.currentRowIdx = rowIndex;
      this.showEditDF = true;
    },
    editRowClose() {
      this.loadData();
      this.$eventHub.$emit("productUpdate");
      this.showEditDF = false;
    },

    showRow(row, rowIndex) {
      this.currentRowId = row.id;
      this.currentRowIdx = rowIndex;
      this.showDF = true;
    },
    showRowClose() {
      this.loadData();
      this.showDF = false;
    },

    // 下载
    download(type) {
      const self = this;
      if (type.indexOf("checked") !== -1) {
        if (
          self.checkedProducts.length === 0 ||
          self.checkedProducts.length > 100000
        ) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: 100000,
          ids: self.checkedProducts.map((c) => c.id),
          exportWithImg: type.indexOf("WithImg") !== -1,
        };
        self.downloadData(data);
      } else {
        if (self.pager.total === 0 || self.pager.total > 100000) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = 100000;
        Vue.set(data, "exportWithImg", type.indexOf("WithImg") !== -1);
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Product.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 批量删除
    batchDelete() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastSelectOneData"),
          type: "warning",
        });
        return;
      }
      Product.batchDelete(self.checkedProducts.map((c) => c.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      Product.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("productDelete");
        } else {
          self.sysError();
        }
      });
    },

    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },

    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records;
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },

    dataProvider(params) {
      return Product.search(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 0 0 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 80px; */
  /* overflow: hidden; */
}
</style>